export default __webpack_public_path__ + "static/media/gb.8dfc4e99.jpg";